@if (signatureReportData.report && signatureReportData.workflowPublishedVersion && workflowPublishedVersion) {
  <app-report
    [report]="signatureReportData.report"
    [workflowPublishedVersion]="workflowPublishedVersion"
    [signatureReportData]= "signatureReportData"
    [users]="signatureReportData.userList"
    [linkId]="linkId"
    [accountInfo]="$safeNavigationMigration(signatureReportData?.accountName)"
    [showSubmittedBy]="true"
    >
  </app-report>
}
